import { fruitData } from "./data";

export const demoData = {
    userInfo: {
        userName: "DEMO GAME",
        balance: 1000,
        isNewUser: false
    },
    betInfo: {
        betSettings: [0.5, 1, 2, 5, 10, 50, 100, 1000],
        minBet: 1,
        maxBet: 1000,
        betMultiplier: 1
    },
    roundInfo: {
        roundSettings: [4, 5, 6, 7, 8, 9, 10, 11, 12],
    },
    sessionInfo: {
        totalRounds: 0,
        totalBet: 0,
        loseLimit: 0
    },
    currentRoundDetails: {
        roundNumber: 0,
        obstacleLane: null,
        roundWinnings: 0,
        gameResult: "pending",
        winType: null,
        multiplier: 1,
        numberOfWins: 0,
        numberOfLosses: 0,
    },
    winRate: {
        UpperSeed: 66,
        lowerSeed: 64.25,
        abateValue: 0.25
    },
    demoPointer: 0
}

let currentWinRate = demoData.winRate.UpperSeed;

export function getValues(winRate) {
    // Simple secure random number between 0 and 1
    function secureRandom() {
        const array = new Uint32Array(1);
        window.crypto.getRandomValues(array);
        return array[0] / 0xFFFFFFFF;
    }

    const random = secureRandom(); // 0 to 1

    // If random < winRate%, it's a win → dodge obstacle
    const shouldWin = random < winRate / 100;

    return shouldWin ? 'coin' : 'bomb';
}

export function placeBetSimulator(totalRounds, totalBet) {

    for (let i = 0; i < totalRounds; i++) {
        const value = getValues(currentWinRate);
        fruitData.roundValues.push(value);
    }    
    console.log("", fruitData.roundValues);
    

     if (currentWinRate >= demoData.winRate.lowerSeed) currentWinRate -= demoData.winRate.abateValue;

    demoData.sessionInfo.totalRounds = totalRounds;
    demoData.sessionInfo.totalBet = totalBet;
    demoData.userInfo.balance -= demoData.sessionInfo.totalBet    

    // demoData.sessionInfo.loseLimit = getLoseLimit(totalRounds)

    return demoData.userInfo.balance;
}
